module.exports = __webpack_public_path__ + "img/oaFlowData170@3x.9346587c.png";